/**
 * WebSocket连接管理器
 */
export class WebSocketManager {
    constructor(url, autoReconnect = true) {
        this.isConnected = false;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectInterval = 2000;
        this.url = url;
        this.autoReconnect = autoReconnect;
    }
    /**
     * 设置消息处理回调
     */
    setMessageHandler(handler) {
        this.messageHandler = handler;
    }
    /**
     * 连接WebSocket
     */
    connect() {
        return new Promise((resolve, reject) => {
            try {
                this.ws = new WebSocket(this.url);
                this.ws.onopen = (event) => {
                    this.handleOpen(event);
                    resolve();
                };
                this.ws.onclose = (event) => {
                    this.handleClose(event);
                };
                this.ws.onerror = (error) => {
                    this.handleError(error);
                    reject(error);
                };
                this.ws.onmessage = (event) => {
                    this.handleMessage(event);
                };
            }
            catch (error) {
                this.handleConnectionFailure(error);
                reject(error);
            }
        });
    }
    /**
     * 断开连接
     */
    disconnect() {
        if (this.ws) {
            this.autoReconnect = false; // 主动断开时不自动重连
            this.ws.close();
            this.ws = undefined;
        }
        this.isConnected = false;
    }
    /**
     * 发送数据
     */
    send(data) {
        if (!this.isConnected || !this.ws) {
            return;
        }
        try {
            const message = typeof data === 'string' ? data : JSON.stringify(data);
            this.ws.send(message);
        }
        catch (error) {
        }
    }
    /**
     * 获取连接状态
     */
    getConnectionStatus() {
        return this.isConnected;
    }
    /**
     * 设置最大重连次数
     */
    setMaxReconnectAttempts(attempts) {
        this.maxReconnectAttempts = attempts;
    }
    /**
     * 设置重连间隔
     */
    setReconnectInterval(interval) {
        this.reconnectInterval = interval;
    }
    /**
     * 计划重连
     */
    scheduleReconnect() {
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
        }
        const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
        this.reconnectAttempts++;
        this.reconnectTimer = setTimeout(() => {
            this.connect().catch(error => {
                if (this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.scheduleReconnect();
                }
            });
        }, delay);
    }
    /**
     * 处理接收到的消息
     */
    handleMessage(event) {
        try {
            const message = JSON.parse(event.data);
            // 调用消息处理回调
            if (this.messageHandler) {
                this.messageHandler(message);
            }
        }
        catch (error) {
        }
    }
    handleOpen(event) {
        this.isConnected = true;
        this.reconnectAttempts = 0;
        if (this.onOpen) {
            this.onOpen(event);
        }
    }
    handleClose(event) {
        this.isConnected = false;
        if (this.onClose) {
            this.onClose(event);
        }
        if (this.autoReconnect && this.reconnectAttempts < this.maxReconnectAttempts) {
            this.scheduleReconnect();
        }
    }
    handleError(error) {
        if (this.onError) {
            this.onError(error);
        }
    }
    handleConnectionFailure(error) {
        if (this.onError) {
            this.onError(error);
        }
    }
}
//# sourceMappingURL=WebSocketManager.js.map